import React from 'react';

class Fbalance extends React.Component {

  componentDidMount() {
    let bankSkin;
    let bankUrl;
    let urlParams;
    let search = window.location.search;
    let isPriv = search.includes('priv=true');
    bankSkin = localStorage.getItem("faktura-skin");
    urlParams = isPriv ? '?main=priv&login=true&site=' + bankSkin : '?login=true&site=' + bankSkin;
    if (search) urlParams += search.replace('?priv=true', '');


    if (bankSkin === 'sovkombank') {
      bankUrl = 'https://elf.sovcombank.ru/elf/app/' + urlParams;
      window.location.replace(bankUrl);
      return false;
    }
    if (bankSkin === 'express-bank') {
      bankUrl = 'https://online.vostbank.ru/app/' + urlParams;
      window.location.replace(bankUrl);
      return false;
    }
    if (bankSkin === 'absolutbank') {
      bankUrl = 'https://online.absolutbank.ru/app/' + urlParams;
      window.location.replace(bankUrl);
      return false;
    }
    if (bankSkin === 'nordeabank') {
      bankUrl = 'https://online.nordea.ru/elf/app/' + urlParams;
      window.location.replace(bankUrl);
      return false;
    }
    if (bankSkin === 'vesta') {
      bankUrl = 'https://ib.vestabank.ru/elf/app/' + urlParams;
      window.location.replace(bankUrl);
      return false;
    }
    if (bankSkin === 'tavrich') {
      bankUrl = 'https://fiz.tavrich.ru/elf/app/' + urlParams;
      window.location.replace(bankUrl);
      return false;
    }
    if (bankSkin === 'bankffin') {
      bankUrl = 'https://online.bankffin.ru/elf/app/' + urlParams;
      window.location.replace(bankUrl);
      return false;
    }
    if (bankSkin === 'baltinvestbank') {
      bankUrl = 'https://online.baltinvest.com/elf/app/' + urlParams;
      window.location.replace(bankUrl);
      return false;
    }
    else {
      bankUrl = '/elf/app/' + urlParams;
      window.location.replace(bankUrl);
      return false;
    }
  }

  render() {
    return <div/>
  }
}

export default Fbalance;
